import './style.css'
import Experience from '@/Experience/Experience'

const canvas = document.querySelector<HTMLCanvasElement>('canvas.webgl')

if (!canvas) {
  throw new Error('Could not find the <canvas class="webgl"> element.')
}

const experience = new Experience(canvas)

// Expose the instance in dev for debugging from the console / tooling.
if (import.meta.env.DEV) {
  ;(window as Window & { experience?: Experience }).experience = experience
}

// Tear the WebGL context down cleanly on Vite HMR so we never leak GPU memory.
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    experience.destroy()
  })
}
